module.exports = "@media screen and (max-width:640px) { \r\n      .tamanio-device {\r\n          width: 290px;\r\n      }\r\n  } "